import React from 'react';
import { Modal, Button } from 'react-bootstrap';

class DenialConfirmationPopUp extends React.Component {
    render() {
        return (
            <Modal show={this.props.visible} onHide={this.props.onCancel}>
                <Modal.Header>
                    <Modal.Title>Confirmation Required</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>You are about to <b>deny</b> this Application, this action cannot be undone.</p>
                    <p>If you wish to continue with this action, please select "Denial Codes"</p>
                    <p style={{ color: 'red', fontWeight: 'bold' }}>You must enter 3-Denial Codes to proceed!</p>
                    <p>If you wish to cancel, please select "Cancel", and you will be returned to the previous screen.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        style={{ backgroundColor: '#d9534f', color: 'black', borderColor: '#d9534f', fontWeight: 'bold' }}
                        onClick={this.props.onDenialCodes}>
                        Denial Codes
                    </Button>
                    <Button bsStyle="primary" onClick={this.props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DenialConfirmationPopUp;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/DenialConfirmationPopUp.js